import { t } from "i18next"
import * as yup from "yup"

const getShareLeadFractionalValidationSchema = () =>
  yup.object().shape({
    sharingType: yup.string(),
    user: yup.string().required(t("User is required")).nullable(),
  })

export default getShareLeadFractionalValidationSchema